<script>
  let { src = "" } = $props();
</script>

<iframe srcdoc={src} frameborder="0" title="Preview iFrame"></iframe>

<style>
  iframe {
    width: 100%;
    min-height: 512px;
  }
</style>
